import { LOADING, GET_ALL_TS_DEALERS, GET_SINGLE_TS_DEALER } from './types'

const initialState = {
  allTSDealers: {},
  tsDealer: {},
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case GET_ALL_TS_DEALERS:
      return {
        ...state,
        isLoading: false,
        allTSDealers: action.payload,
      }
    case GET_SINGLE_TS_DEALER:
      return {
        ...state,
        isLoading: false,
        tsDealer: action.payload,
      }
    default:
      return state
  }
}
